import $ from 'jquery';
import 'arrive';

$(document).ready(function () {
    document.arrive('.srg-posts-list-container', {existing: true}, function () {
        let $block = $(this);
        $block.find('.press-filters select').change({block: $block}, function (e) {
            let query_vars = {
                post_type: 'press',
                post_status: 'publish',
                posts_per_page: 1000,
                orderby: 'date',
                orderway: 'DESC',
                custom_filters: {
                    taxonomy: 'category_press',
                }
            };
            let year = parseInt($('#year').val());
            let cat = parseInt($('#cat').val());
            if (year) {
                query_vars['date_query'] = {
                    0: {
                        'year': year,
                        compare: '=',
                    },
                };
            }
            if (cat) {
                query_vars['tax_query'] = {
                    0: {
                        taxonomy: 'category_press',
                        field: 'term_taxonomy_id',
                        terms: cat,
                    },
                };
            }
            let loader = e.data.block.find('.srg-loader');
            $.ajax({
                url: srg.ajaxurl,
                type: 'post',
                dataType: 'json',
                data: {
                    action: 'get_presses',
                    query_vars: JSON.stringify(query_vars),
                },
                success: function (results) {
                    loader.show();
                    // results = JSON.parse(results); // no need to parse it, results is already a json object
                    e.data.block.find('.srg-slick-files-slider').replaceWith(results.list);
                    updateFilters(Object.keys(results.years).map((key) => String(results.years[key])), Object.keys(results.cats).map((key) => String(results.cats[key])));
                    loader.hide();
                },
            });
        });

        $('.contacts-title').click(function () {
            if ($(window).width() <= 768) {
                $(this)
                    .next()
                    .slideToggle('medium', function () {
                        if ($(this).is(':visible')) $(this).css('display', 'flex');
                    });
                $(this).toggleClass('active');
                $('.press-filters').parent().children().slideToggle();
            }
        });

        $(window).resize(function () {
            if ($(window).width() > 768) {
                $('.contacts-title').next().css('display', '');
                $('.contacts-title').removeClass('active');
                $('.press-filters').parent().children().show();
            }
        });
    })
})

function updateFilters(years = [],cats = [] ) {
    $('#year ~ .srg-custom-select-options').find('li:not(:first-of-type)').each(function () {
        if (!years.length || years.indexOf($(this).attr('rel')) !== -1) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });
    $('#cat ~ .srg-custom-select-options').find('li:not(:first-of-type)').each(function () {
        if (!cats.length || cats.indexOf($(this).attr('rel')) !== -1) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });
}